import React from 'react';

import { ScrollArea, Text } from '@mantine/core';
import { IconWand } from '@tabler/icons-react';
import { useToolGroups } from 'hooks/Tools/use-tool-groups';
import { OverviewCard } from 'pages/GuestSmartAssistant/GuestDashboard/OverviewTab/OverviewCard';
import { StaticToolGroupPreview } from 'pages/ManageSmartAssistant/Sections/ToolsSection/StaticToolGroupPreview';
import { useTranslation } from 'react-i18next';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';

interface ToolsOverviewProps {
  smartAssistant: SmartAssistant;
}

export function ToolsOverview({ smartAssistant }: ToolsOverviewProps) {
  const { t } = useTranslation();
  const existingToolConfigs = smartAssistant.toolConfigs ?? [];
  const { attachedToolGroups } = useToolGroups({ smartAssistantType: smartAssistant.type, existingToolConfigs });

  return (
    <OverviewCard title={t('SMART_ASSISTANT.OVERVIEW_SECTION.TOOLS.TITLE')} icon={<IconWand />}>
      <ScrollArea h="100%">
        {attachedToolGroups.map((toolGroup) => (
          <StaticToolGroupPreview key={toolGroup.kind} staticToolGroup={toolGroup} />
        ))}
        {attachedToolGroups.length === 0 && (
          <Text size="sm" c="dimmed">
            {t('SMART_ASSISTANT.OVERVIEW_SECTION.TOOLS.NO_TOOLS')}
          </Text>
        )}
      </ScrollArea>
    </OverviewCard>
  );
}
